import useSEO from "../lib/useSEO";
import LeadForm from "../components/sections/LeadForm";
import FinalCTA from "../components/sections/FinalCTA";
import { Check, MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { WHATSAPP_URL } from "../lib/site-data";

const FACTORS = [
    "Dövmenin / izin boyutu",
    "Dövmedeki renk yoğunluğu ve renk sayısı",
    "Dövme/izin yaşı (ne kadar süredir var)",
    "Lokalizasyon (vücut bölgesi)",
    "Cilt tipi ve iyileşme sürecinin değerlendirilmesi",
    "Önerilen seans sayısı",
];

export default function Fiyatlar() {
    useSEO({
        title: "Dövme Silme Fiyatları | İstanbul Dövme Silme",
        description:
            "Dövme silme fiyatları kişisel ön değerlendirme sonrası belirlenir. Fiyatlandırmayı etkileyen faktörler hakkında bilgi.",
        canonical: "https://www.istanbuldovmesilme.com/dovme-silme-fiyatlari",
    });

    return (
        <>
            <section className="py-20 md:py-28 border-b border-white/5">
                <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16">
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-300/80 mb-3">
                        Fiyat Bilgisi
                    </p>
                    <h1 className="font-display text-4xl md:text-6xl text-white tracking-tight mb-6 text-balance">
                        Dövme Silme Fiyatları
                    </h1>
                    <p className="text-base md:text-lg text-zinc-400 max-w-3xl leading-relaxed">
                        Net fiyat; dövme/iz boyutu, rengi, lokalizasyonu ve seans sayısına göre
                        kişisel değerlendirme sonrası paylaşılır. Bu sayfada fiyatlandırmayı etkileyen
                        faktörler hakkında ön bilgi bulabilirsiniz. Sağlıklı bir bilgi için fotoğraf
                        ile WhatsApp üzerinden iletişime geçmenizi öneririz.
                    </p>

                    <div className="grid md:grid-cols-2 gap-3 mt-10 max-w-3xl">
                        {FACTORS.map((f) => (
                            <div
                                key={f}
                                className="bg-[#0E0E0E] border border-white/5 rounded-xl p-4 flex items-start gap-3"
                            >
                                <Check className="h-4 w-4 text-cyan-300 mt-1 flex-shrink-0" />
                                <span className="text-sm text-zinc-300">{f}</span>
                            </div>
                        ))}
                    </div>

                    <div className="mt-10">
                        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                            <Button className="bg-cyan-400 text-black hover:bg-cyan-300 font-medium px-7 py-6">
                                <MessageCircle className="h-5 w-5 mr-2" />
                                Fotoğraf ile Fiyat Bilgisi Al
                            </Button>
                        </a>
                    </div>

                    <p className="text-xs text-zinc-500 mt-8 max-w-2xl leading-relaxed">
                        Fiyat ve seans sayısı garantisi verilmez. Sonuçlar kişiden kişiye değişebilir.
                    </p>
                </div>
            </section>
            <LeadForm />
            <FinalCTA />
        </>
    );
}
